module.exports = __webpack_public_path__ + "static/media/header-my-order.b9a05f70.jpg";